import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'styled-components';
import { SpaceBetween, Switch, tk, Typography } from '@sunwebgroup/ui-components';
import { useUserReviews } from '@/scopes/products/user-reviews/hooks';
import { createUserReviewsEvent } from '../../../../user-reviews/infrastructure/analytics';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';

const Wrapper = styled(SpaceBetween)`
  padding-top: ${tk('spacing_sm')};
  padding-bottom: ${tk('spacing_sm')};

  ${Switch} {
    margin-right: ${tk('spacing_xs')};
  }
`;

export function InWebsiteLanguageFilter() {
  const intl = useIntl();

  const { showOnlyInWebsiteLanguage, setShowOnlyInWebsiteLanguage } = useUserReviews();
  const { sendEvent } = useAnalytics();

  const handleOnCheckedChange = () => {
    sendEvent(
      createUserReviewsEvent({
        description: 'show review in own language',
        element: 'Toggle',
        result: showOnlyInWebsiteLanguage ? 'off' : 'on',
      })
    );
    setShowOnlyInWebsiteLanguage(!showOnlyInWebsiteLanguage);
  };

  return (
    <Wrapper direction="x" alignItems="center">
      <Switch checked={showOnlyInWebsiteLanguage} onCheckedChange={handleOnCheckedChange} />
      <Typography $variant="label-thin">{intl.formatMessage({ id: 'reviews_all_in_my_language' })}</Typography>
    </Wrapper>
  );
}
